import { EnumUserTypes } from "@utils/constants";
import { IAvailabilitySlot } from "../MeetingDetailPage";
import store from "@store/index";
import { IGeneralSlotResponse } from "@endpoints/types/interview.type";

// To check if the slot is disabled for current user due to slot declined by another user (Candidate | Company | Recruiter)
export function checkIsSlotDisabled(slot: IAvailabilitySlot) {
    const currentUserType = store.getState()?.auth?.user?.userType
    if (currentUserType === EnumUserTypes.CANDIDATE) {
        return slot?.isCompanyAvailable === false || slot?.isRecruiterAvailable === false
    } else if (currentUserType === EnumUserTypes.RECRUITER) {
        return slot?.isCompanyAvailable === false || slot?.isCandidateAvailable === false
    }
    else if (currentUserType === EnumUserTypes.HIRING_COMPANY) {
        return slot?.isCandidateAvailable === false || slot?.isRecruiterAvailable === false
    }
}


// Check if the current user has responded all the given slots or not
export function isAllSlotResponded(slots: IAvailabilitySlot[]) {
    const currentUserType = store.getState()?.auth?.user?.userType
    if (currentUserType === EnumUserTypes.CANDIDATE) {
        return slots?.every((slot) => {
            return slot?.isCandidateAvailable || slot?.isCandidateAvailable === false || checkIsSlotDisabled(slot)
        })
    } else if (currentUserType === EnumUserTypes.RECRUITER) {
        return slots?.every((slot) => {
            return slot?.isRecruiterAvailable || slot?.isRecruiterAvailable === false || checkIsSlotDisabled(slot)
        })
    }
    else if (currentUserType === EnumUserTypes.HIRING_COMPANY) {
        return slots?.every((slot) => {
            return slot?.isCompanyAvailable || slot?.isCompanyAvailable === false || checkIsSlotDisabled(slot)
        })
    }
}

// Check if the current slot qualifies for final invite confirmation.
// A slot is eligible when all participants except the current user have accepted it.
export function isSlotReadyForInvite(slots: IAvailabilitySlot[]) {
    const currentUserType = store.getState()?.auth?.user?.userType
    if (currentUserType === EnumUserTypes.CANDIDATE) {
        return slots?.some((slot) => slot?.isCompanyAvailable && slot?.isRecruiterAvailable)
    } else if (currentUserType === EnumUserTypes.RECRUITER) {
        return slots?.some((slot) => slot?.isCompanyAvailable && slot?.isCandidateAvailable)
    }
    else if (currentUserType === EnumUserTypes.HIRING_COMPANY) {
        return slots?.some((slot) => slot?.isCandidateAvailable && slot?.isRecruiterAvailable)
    }
}


export type slotStatus = "Accepted" | "Declined" | "Pending" | 'Auto-Declined';

// Return the slot status label based on particular user
// export function getSlotStatus({
//     slot,
//     statusOf,
// }: {
//     slot: IGeneralSlotResponse;
//     statusOf?: EnumUserTypes;
// }): slotStatus {
//     const isProposedBy = slot?.proposedBy?.userType;

//     if (isProposedBy === EnumUserTypes.RECRUITER) {
//         if (
//             (!slot?.isCompanyAvailable &&
//                 slot?.isCompanyAvailable === false &&
//                 statusOf === EnumUserTypes.HIRING_COMPANY) ||
//             (!slot?.isCandidateAvailable &&
//                 slot?.isCandidateAvailable === false &&
//                 statusOf === EnumUserTypes.CANDIDATE)
//         ) {
//             return "Declined";
//         } else if (
//             (slot?.isCompanyAvailable &&
//                 slot?.isCompanyAvailable === true &&
//                 statusOf === EnumUserTypes.HIRING_COMPANY) ||
//             (slot?.isCandidateAvailable &&
//                 slot?.isCandidateAvailable === true &&
//                 statusOf === EnumUserTypes.CANDIDATE)
//         ) {
//             return "Accepted";
//         } else if (
//             (slot?.isCandidateAvailable === false &&
//                 statusOf === EnumUserTypes.HIRING_COMPANY) ||
//             (slot?.isCompanyAvailable === false &&
//                 statusOf === EnumUserTypes.CANDIDATE)
//         ) {
//             return 'Auto-Declined';
//         } else {
//             return "Pending";
//         }
//     }

//     if (isProposedBy === EnumUserTypes.CANDIDATE) {
//         if (
//             (!slot?.isCompanyAvailable &&
//                 slot?.isCompanyAvailable === false &&
//                 statusOf === EnumUserTypes.HIRING_COMPANY) ||
//             (!slot?.isRecruiterAvailable &&
//                 slot?.isRecruiterAvailable === false &&
//                 statusOf === EnumUserTypes.RECRUITER)
//         ) {
//             return "Declined";
//         } else if (
//             (slot?.isCompanyAvailable &&
//                 slot?.isCompanyAvailable === true &&
//                 statusOf === EnumUserTypes.HIRING_COMPANY) ||
//             (slot?.isRecruiterAvailable &&
//                 slot?.isRecruiterAvailable === true &&
//                 statusOf === EnumUserTypes.RECRUITER)
//         ) {
//             return "Accepted";
//         } else if (
//             (slot?.isRecruiterAvailable === false &&
//                 statusOf === EnumUserTypes.HIRING_COMPANY) ||
//             (slot?.isCompanyAvailable === false &&
//                 statusOf === EnumUserTypes.RECRUITER)
//         ) {
//             return 'Auto-Declined';
//         }
//         else {
//             return "Pending";
//         }
//     }

//     if (isProposedBy === EnumUserTypes.HIRING_COMPANY) {
//         if (
//             (!slot?.isCandidateAvailable &&
//                 slot?.isCandidateAvailable === false &&
//                 statusOf === EnumUserTypes.CANDIDATE) ||
//             (!slot?.isRecruiterAvailable &&
//                 slot?.isRecruiterAvailable === false &&
//                 statusOf === EnumUserTypes.RECRUITER)
//         ) {
//             return "Declined";
//         } else if (
//             (slot?.isCandidateAvailable &&
//                 slot?.isCandidateAvailable === true &&
//                 statusOf === EnumUserTypes.CANDIDATE) ||
//             (slot?.isRecruiterAvailable &&
//                 slot?.isRecruiterAvailable === true &&
//                 statusOf === EnumUserTypes.RECRUITER)
//         ) {
//             return "Accepted";
//         } else if (
//             (slot?.isRecruiterAvailable === false &&
//                 statusOf === EnumUserTypes.CANDIDATE) ||
//             (slot?.isCandidateAvailable === false &&
//                 statusOf === EnumUserTypes.RECRUITER)
//         ) {
//             return 'Auto-Declined';
//         } else {
//             return "Pending";
//         }
//     }
// }
export function getSlotStatus({
    slot,
    statusOf,
}: {
    slot: IGeneralSlotResponse;
    statusOf?: EnumUserTypes;
}): slotStatus {
    const isProposedBy = slot?.proposedBy?.userType;

    if (isProposedBy === EnumUserTypes.RECRUITER) {
        if (
            (!slot?.isCompanyAvailable &&
                slot?.isCompanyAvailable === false &&
                statusOf === EnumUserTypes.HIRING_COMPANY) ||
            (!slot?.isCandidateAvailable &&
                slot?.isCandidateAvailable === false &&
                statusOf === EnumUserTypes.CANDIDATE)
        ) {
            return "Declined";
        } else if (
            (slot?.isCompanyAvailable &&
                slot?.isCompanyAvailable === true &&
                statusOf === EnumUserTypes.HIRING_COMPANY) ||
            (slot?.isCandidateAvailable &&
                slot?.isCandidateAvailable === true &&
                statusOf === EnumUserTypes.CANDIDATE)
        ) {
            return "Accepted";
        } else if (
            ((slot?.isRecruiterAvailable === false ||
                slot?.isCandidateAvailable === false) &&
                slot?.isCompanyAvailable !== false &&
                statusOf === EnumUserTypes.HIRING_COMPANY) ||
            ((slot?.isRecruiterAvailable === false ||
                slot?.isCompanyAvailable === false) &&
                slot?.isCandidateAvailable !== false &&
                statusOf === EnumUserTypes.CANDIDATE)
        ) {
            return "Auto-Declined";
        } else {
            return "Pending";
        }
    }

    if (isProposedBy === EnumUserTypes.CANDIDATE) {
        if (
            (!slot?.isCompanyAvailable &&
                slot?.isCompanyAvailable === false &&
                statusOf === EnumUserTypes.HIRING_COMPANY) ||
            (!slot?.isRecruiterAvailable &&
                slot?.isRecruiterAvailable === false &&
                statusOf === EnumUserTypes.RECRUITER)
        ) {
            return "Declined";
        } else if (
            (slot?.isCompanyAvailable &&
                slot?.isCompanyAvailable === true &&
                statusOf === EnumUserTypes.HIRING_COMPANY) ||
            (slot?.isRecruiterAvailable &&
                slot?.isRecruiterAvailable === true &&
                statusOf === EnumUserTypes.RECRUITER)
        ) {
            return "Accepted";
        } else if (
            ((slot?.isRecruiterAvailable === false ||
                slot?.isCandidateAvailable === false) &&
                slot?.isCompanyAvailable !== false &&
                statusOf === EnumUserTypes.HIRING_COMPANY) ||
            ((slot?.isCandidateAvailable === false ||
                slot?.isCompanyAvailable === false) &&
                slot?.isRecruiterAvailable !== false &&
                statusOf === EnumUserTypes.RECRUITER)
        ) {
            return "Auto-Declined";
        } else {
            return "Pending";
        }
    }

    if (isProposedBy === EnumUserTypes.HIRING_COMPANY) {
        if (
            (!slot?.isCandidateAvailable &&
                slot?.isCandidateAvailable === false &&
                statusOf === EnumUserTypes.CANDIDATE) ||
            (!slot?.isRecruiterAvailable &&
                slot?.isRecruiterAvailable === false &&
                statusOf === EnumUserTypes.RECRUITER)
        ) {
            return "Declined";
        } else if (
            (slot?.isCandidateAvailable &&
                slot?.isCandidateAvailable === true &&
                statusOf === EnumUserTypes.CANDIDATE) ||
            (slot?.isRecruiterAvailable &&
                slot?.isRecruiterAvailable === true &&
                statusOf === EnumUserTypes.RECRUITER)
        ) {
            return "Accepted";
        } else if (
            ((slot?.isRecruiterAvailable === false ||
                slot?.isCompanyAvailable === false) &&
                slot?.isRecruiterAvailable !== false &&
                statusOf === EnumUserTypes.RECRUITER) ||
            ((slot?.isRecruiterAvailable === false ||
                slot?.isCompanyAvailable === false) &&
                slot?.isCandidateAvailable !== false &&
                statusOf === EnumUserTypes.CANDIDATE)
        ) {
            return "Auto-Declined";
        } else {
            return "Pending";
        }
    }
}
